import { environment } from 'src/environments/environment';

export function getAssetUrl(path: string) {
  const url = new URL(path, environment.staticURL);
  return url.href;
}
